import { GetAllBoostHistoryQueryParams } from '../../../types/api/endpoints/boost/history.types';
import { BOOSTS_ENDPOINTS } from '../../../utils/api/endpoints/boostsEndpoints';
import { GetAllBoostHistoryResponse } from './useAllBoostsHistory.types';

const PREFIX = '[allBoostsHistoryQuery]';

export const allBoostsHistoryQuery = async (params: GetAllBoostHistoryQueryParams) => {
  console.log(PREFIX, `Fetching all boosts history...`);

  const response = await BOOSTS_ENDPOINTS.getAllHistory(params);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received all boosts history..`);
  return json as GetAllBoostHistoryResponse;
};
